import { Injectable } from '@angular/core';

export enum PanelEventNames {
    Open,
    SizeChanged
}

export type OnEvent = (eventName: PanelEventNames, panelId: string, args?: unknown) => void;

type Panels = { panelId: string; onEvent: OnEvent }[];

@Injectable({
    providedIn: 'root'
})
export class PanelService {

    public constructor() { }

    public observables: { wrapperId: string, panels: Panels }[] = [];

    public addWrapper(wrapperId: string): () => void {
        const panelWrapperHook = { wrapperId: wrapperId, panels: []};
        this.observables.push(panelWrapperHook);
        return () => {
            const idx = this.observables.indexOf(panelWrapperHook);
            this.observables.splice(idx, 1);
        };
    }

    public addObserver(wrapperId: string, panelId: string, onEvent: OnEvent): () => void {
        const observable = this.observables.find( o => o.wrapperId === wrapperId);
        const panelHook = { panelId, onEvent };
        if (observable) {
            observable.panels.push(panelHook);
        }
        return () => {
            if (observable !== void 0) {
                const observablesIdx = this.observables.indexOf(observable);
                const hookIdx = this.observables[observablesIdx].panels.indexOf(panelHook);
                this.observables[observablesIdx].panels.splice(hookIdx, 1);
            }
        };
    }

    public notify(wrapperId: string, panelId: string, eventName: PanelEventNames, args?: unknown): void {
        const observable = this.observables.find( o => o.wrapperId === wrapperId);
        if (!observable) return;
        observable.panels.forEach(o => {
            o.onEvent(eventName, panelId, args);
        });
    }
}
